module.exports = __webpack_public_path__ + "static/media/2-min.eb05afc4.png";